import React, { useState, FormEvent, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Formulario, { FormField } from "../../../../components/Formulario";
import { createFabricante } from "../../../../api/fabricanteApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getEmpresas } from "../../../../api/empresaApi";
import { Empresa } from "../../../../types/empresas";

const AdicionarFabricante: React.FC = () => {
  const [descricaoFabricante, setdescricaoFabricante] = useState<string>("");
  const [idEmpresa, setIdEmpresa] = useState<Empresa | null>(null);
  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const empresasData = await getEmpresas(token);
        setEmpresas(empresasData);
      } catch (error) {
        toast.error("Erro ao buscar empresas!");
        console.error("Erro ao buscar empresas:", error);
      }
    };

    
    fetchEmpresas();
  }, []);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      if (!idEmpresa) {
        toast.error("Selecione uma empresa!");
        return;
      }      

      const formData = new FormData();
      formData.append("descricao_fabricante", descricaoFabricante);
      formData.append("id_empresa", idEmpresa.id.toString());

      await createFabricante(token, formData);
      toast.success("Fabricante criado com sucesso!");
      navigate("/fabricantes");
    } catch (error) {
      toast.error("Erro ao adicionar fabricante!");
      console.error("Erro ao adicionar fabricante:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleEmpresaChange = (event: React.SyntheticEvent, value: Empresa | null) => {
    setIdEmpresa(value);
  };  

  const fields: FormField[] = [
    {
      label: "Nome do Fabricante",
      type: "text",
      value: descricaoFabricante,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setdescricaoFabricante(e.target.value),
    },
    {
      label: "Empresa",
      type: "autocomplete",
      value: idEmpresa,
      required: true,
      onChangeAutocomplete: handleEmpresaChange,
      options: empresas,
      getOptionLabel: (option: Empresa) => option.nome_empresa,
    },
  ];

  return (
    <Formulario
      title="Adicionar Fabricante"
      fields={fields}
      onSubmit={handleSubmit}
      loading={loading}
      onBack={handleBack}
    />
  );
};

export default AdicionarFabricante;
